<template>
  <div class="pain-location">
    <div class="pain-location__container">
      <h2
        class="pain-location__header"
        v-html="$t('b2b__landing_page__pain_location__header')"
      />

      <div class="pain-location__buttons">
        <button
          v-for="bodyPart in bodyPartButtons"
          :key="bodyPart.id"
          class="pain-location__button"
          type="button"
          @click="goToNextStep"
        >
          {{ $t(bodyPart.labelKey) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  handleCTAButtonClick: {
    type: Function,
    default: () => {},
  },
})

const bodyPartButtons = [
  {
    id: 'lower-back',
    labelKey: 'b2b__landing_page__pain_location__button_lower_back',
  },
  {
    id: 'shoulder',
    labelKey: 'b2b__landing_page__pain_location__button_shoulder',
  },
  { id: 'knee', labelKey: 'b2b__landing_page__pain_location__button_knee' },
  { id: 'hip', labelKey: 'b2b__landing_page__pain_location__button_hip' },
  { id: 'neck', labelKey: 'b2b__landing_page__pain_location__button_neck' },
  {
    id: 'upper-back',
    labelKey: 'b2b__landing_page__pain_location__button_upper_back',
  },
  {
    id: 'ankle-foot',
    labelKey: 'b2b__landing_page__pain_location__button_ankle_foot',
  },
  { id: 'elbow', labelKey: 'b2b__landing_page__pain_location__button_elbow' },
  {
    id: 'pelvic-health',
    labelKey: 'b2b__landing_page__pain_location__button_pelvic_health',
  },
  { id: 'other', labelKey: 'b2b__landing_page__pain_location__button_other' },
]

const goToNextStep = () => {
  props.handleCTAButtonClick()
}
</script>

<style lang="scss" scoped>
.pain-location {
  background-color: $kds-color-background-base;
  padding: 40px 10px;

  @include media-up(lg) {
    padding: 72px 10px;
  }

  &__container {
    @extend %container;
    margin: 0 auto;
  }

  &__header {
    @include kds-typography-display-small;
    font-weight: $kds-typography-font-weight-medium;
    text-align: center;
    margin: 0 0 $kds-space-6x;

    @include media-up(md) {
      @include kds-typography-display-medium;
      font-weight: $kds-typography-font-weight-medium;
    }

    @include media-up(lg) {
      :deep(.pain-location__header-break-mobile-tablet) {
        display: none;
      }
    }
  }

  &__buttons {
    display: grid;
    grid-template-columns: 1fr;
    gap: 12px;

    @include media-up(md) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    @include media-up(lg) {
      grid-template-columns: repeat(3, minmax(0, 1fr));
    }
  }

  &__button {
    @include kds-typography-title-medium;
    background-color: $kds-color-background-base;
    border: 1px solid $kds-color-background-accent;
    border-radius: 8px;
    color: $kds-color-text-primary;
    min-height: 5rem;
    padding: $kds-space-1_5x 14px;
    text-align: left;
    cursor: pointer;

    &:hover,
    &:focus-visible {
      background-color: $kds-color-background-subtle;
      border-color: $kds-color-background-strong;
      outline: none;
    }
  }

  @include media-between(md, 1023px) {
    &__buttons {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}
</style>
